import React, { useCallback }  from 'react'
import { useDropzone } from 'react-dropzone'
import PublishIcon from '@material-ui/icons/Publish';
import { useDropZoneDispatch } from '../contexts/drop-zone-context'
import './style.css'

/*
    allowedFileExtensions is an array and refers to the files extensions eg .png, .csv etc
    allowedMimeTypes can be a string or string array and refers to the MIME types eg text/csv, image/*
    fileDescription refers to the displayed description of the file in the drop zone
    eg Drag and drop the {fileDescription} file here
 */
const DropZone = ({allowedFileExtensions, allowedMimeTypes, fileDescription}) => {
    const { selectFile } = useDropZoneDispatch()

    const isFileExtensionAllowedFormat = (filename) => {
        const format = filename.split('.').pop()
        if (!allowedFileExtensions.includes(format.toLowerCase())) return false
        return true
    }

    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles && acceptedFiles.length && isFileExtensionAllowedFormat(acceptedFiles[0].name)) {
            selectFile(acceptedFiles[0])
        } else {
            alert(`Only files in the following formats are accepted: ${allowedFileExtensions.toString()}`)
        }
    }, [])

    const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: allowedMimeTypes})

    return (
        <div {...getRootProps({ className: "drop-zone" })} >
            <input {...getInputProps()} />
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className="icon-wrapper">
                    <PublishIcon fontSize="large" style={{ color: "#8d8d8d" }}/>
                </div>
                <div className="message-wrapper">
                    <p><span className="strong">Drag and drop</span> {`the ${fileDescription} file here `}</p>
                    <p>or <span className="strong">click here to browse</span> to begin upload</p>
                </div>
            </div>
        </div>
    )
}

export default DropZone